import React from 'react';
// mui components
import { Box, Typography } from '@mui/material';
// draft-js-plugins types
import { SubMentionComponentProps } from '@draft-js-plugins/mention/lib/Mention';

const Mention: React.FC<SubMentionComponentProps> = ({ decoratedText }) => {
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        padding: '0 2px',
        borderRadius: '8px',
        background: '#E7ECFF',
        verticalAlign: 'middle',
      }}
    >
      <Typography
        component="span"
        sx={{
          display: 'inline',
          verticalAlign: 'middle',
          fontFamily: 'Inter',
          fontStyle: 'normal',
          fontWeight: '400',
          fontSize: '14px',
          lineHeight: '146%',
          color: '#3652C6',
        }}
      >
        {decoratedText}
      </Typography>
    </Box>
  );
};

export default Mention;
